import type { User } from '@blackboard/shared';

export type Principal = 'email' | 'student_id';

export interface ChallengeResult {
  challenge_uid: string;
  expires_at: string;
}

export type ApiResult<T> = T | { error: string; code?: string };

export function isErr<T>(r: ApiResult<T>): r is { error: string; code?: string } {
  return !!r && typeof r === 'object' && 'error' in r;
}

export async function startChallenge(
  principalType: Principal,
  principalValue: string,
): Promise<ApiResult<ChallengeResult>> {
  try {
    const res = await fetch('/api/auth/nju/challenge', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        principal_type: principalType,
        principal_value: principalValue,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { error: data?.error ?? `请求失败（${res.status}）`, code: data?.code };
    return data as ChallengeResult;
  } catch {
    return { error: '网络异常，请稍后重试。' };
  }
}

export async function verifyChallenge(
  challengeUid: string,
  code: string,
): Promise<ApiResult<{ accessToken: string; user: User }>> {
  try {
    const res = await fetch('/api/auth/nju/verify', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ challenge_uid: challengeUid, challenge_code: code }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) return { error: data?.error ?? `验证失败（${res.status}）`, code: data?.code };
    return data as { accessToken: string; user: User };
  } catch {
    return { error: '网络异常，请稍后重试。' };
  }
}
